import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../App';
import { Container, Row, Col, Form, Button, Spinner, Modal } from 'react-bootstrap';
import $ from 'jquery';
import 'jquery-confirm';
import { toast, Bounce } from 'react-toastify';
import { makePostCall } from '../utils/apiHelper';

export const BusinessWithUs = () => {
    const { load, leads, getLoad, setLeads, link, accessToken, setAuthForm, formatDateTime, enquiryTypes, customers, setEnquiryTypes,
        getCustomers, getCall, setGetLoad, setCustomers } = useContext(AppContext);
    const [tabState, setTabState] = useState('home');
    const getResolved = (key) => {
        setTabState(key);
        // Update button states
        document.querySelectorAll('.works-nav-item').forEach((btn, idx) => {
            btn.classList.remove('active');
        });
        const buttons = document.querySelectorAll('.works-nav-item');
        const indicator = document.querySelector('.works-nav-indicator');
        if (key === 'home') {
            buttons[0].classList.add('active');
            indicator.style.left = '6px';
            indicator.style.width = '50%'
        } else if (key === 'history') {
            buttons[1].classList.add('active');
            indicator.style.left = 'calc(50% - 2px)';
            indicator.style.width = '50%'
        }
        // Update content visibility
        document.querySelectorAll('.works-tab-content').forEach((content, idx) => {
            content.style.display = 'none';
        });
        const contents = document.querySelectorAll('.works-tab-content');
        if (key === 'home') contents[0].style.display = 'block';
        else if (key === 'history') contents[1].style.display = 'block';
    }
    const [details, setDetails] = useState();
    const [detailsLoad, setDetailsLoad] = useState(false);
    const [detailModal, setDetailModal] = useState(false);
    const getDetails = (id) => {
        if (id === undefined || id === null) {
            toast.error('Something went wrong');
            return;
        }
        setDetailsLoad(true);
        setDetailModal(true);
        makePostCall(link, 'api/e/get/lead/details/', { l_id: id.substring(1) }, accessToken, setAuthForm).then((res) => {
            setDetails(res?.data);
            setDetailsLoad(false);
        }).catch(() => { });
    }
    const getEssentials = async () => {
        if (enquiryTypes === undefined) {
            await getCall(setGetLoad, 'api/e/get/enquiry/types/', setEnquiryTypes);
        }
        if (customers === undefined) {
            await getCustomers();
        }
        setNewModal(true);
    }
    const [newModal, setNewModal] = useState(false);
    const [newEnquiryModel, setNewEnquiryModel] = useState(false);
    const [phoneReqErr, setPhoneReqErr] = useState(false);
    const [nameReqErr, setNameReqErr] = useState(false);
    const [eqTitleErr, setEqTitleErr] = useState(false);
    const [eqDetailsErr, setEqDetailsErr] = useState(false);
    const [selectCount, setSelectCount] = useState(-1);
    const [showAutoSuggestion, setShowAutoSuggestion] = useState(false);
    const [selectedItem, setSelectedItem] = useState();
    useEffect(() => {
        if (selectedItem !== undefined) {
            $('#cus_phone').val(selectedItem.profile.phone);
            $('#cus_name').val(selectedItem.profile.name);
            $('#cus_address').val(selectedItem.profile.address);
        } else {
            $('#cus_name').val('');
            $('#cus_address').val('');
        }
    }, [selectedItem]);
    const [searchResult, setSearchResult] = useState({});
    const searchCustomer = (c_num) => {
        setSearchResult(prev => { });
        if (c_num !== "") {
            if (customers !== undefined) {
                setSelectedItem();
                if (Object.keys(customers).length > 0) {
                    setSelectCount(-1);
                    setShowAutoSuggestion(true);
                    let count = 0;
                    Object.keys(customers).map(customer => {
                        if (customers[customer].phone.match(c_num)) {
                            if (count < 20) {
                                setSearchResult(prev => ({ ...prev, [customer]: customers[customer] }))
                                count += 1;
                            }
                        }
                    });
                }
            }
        } else {
            setSearchResult(prev => { });
        }
    }
    $('#cus_phone').off().on("keydown", function (e) {
        var code = e.which || e.keyCode;
        if (code === 40) {
            e.preventDefault();
            if (selectCount < Object.keys(searchResult).length - 1) {
                setSelectCount(prev => prev + 1);
            } else {
                setSelectCount(0);
            }
        } else if (code === 38) {
            e.preventDefault();
            if (selectCount > 0) {
                setSelectCount(prev => prev - 1);
            } else {
                setSelectCount(Object.keys(searchResult).length - 1);
            }
        } else if (code === 13) {
            e.preventDefault();
            setShowAutoSuggestion(false);
            if (selectCount >= 0) {
                setSelectedItem({ id: Object.keys(searchResult)[selectCount], profile: searchResult[Object.keys(searchResult)[selectCount]] });
            }
        }
    });
    const [addEnquiryLoad, setAddEnquiryLoad] = useState(false);
    const addEnquiry = (e) => {
        e.preventDefault();
        let phone = e.target.phone.value;
        let name = e.target.name.value;
        let address = e.target.address.value;
        let type = e.target.enquiry_type.value;
        let details = e.target.details.value;
        if (phone === "") {
            setPhoneReqErr(true);
            setTimeout(() => { setPhoneReqErr(false) }, 5000);
        }
        if (name === "") {
            setNameReqErr(true);
            setTimeout(() => { setNameReqErr(false) }, 5000);
        }
        if (type === "") {
            setEqTitleErr(true);
            setTimeout(() => { setEqTitleErr(false) }, 5000);
        }
        if (details === "") {
            setEqDetailsErr(true);
            setTimeout(() => { setEqDetailsErr(false) }, 5000);
        }
        if (phone !== "" && name !== "" && type !== "" && details !== "") {
            setAddEnquiryLoad(true);
            makePostCall(link, 'api/e/add/lead/from/admin/', {
                customer_id: selectedItem !== undefined ? selectedItem.id.substring(1) : '',
                name: name,
                phone: phone,
                address: address,
                type: type,
                note: details,
            }, accessToken, setAuthForm).then((res) => {
            }).then((res) => {
                res.data.status ? toast.success('Enquiry added successfully') : toast.error('Failed to add enquiry');
                if (res.data.status) {
                    setNewModal(false);
                    setLeads(prev => ({ ...prev, [res.data.l_id]: res.data.l_data }));
                    setCustomers(prev => ({ ...prev, [res.data.c_id]: res.data.c_data }));
                }
                setAddEnquiryLoad(false);
            }).catch((err) => {
                setAddEnquiryLoad(false);
            });

        }
    }
    return (
        <Container fluid>
            <div className="works-nav-container">
                <div className="works-nav-wrapper">
                    <button className="works-nav-item active" onClick={() => getResolved('home')}>
                        <i className="bi bi-clock"></i>
                        <span>Active Leads</span>
                    </button>
                    <button className="works-nav-item" onClick={() => getResolved('history')}>
                        <i className="bi bi-check-circle"></i>
                        <span>Closed Leads</span>
                    </button>
                    <div className="works-nav-indicator business-nav-indicator"></div>
                </div>
            </div>
            <div className="bgp flex-wrap p-2 justify-content-between align-items-center br-3 mb-1" >
                <span className='px-2' >{getLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Leads'}</span>
                <div className="flex-wrap align-items-center justify-content-end gap-2" >
                    <Button onClick={() => { getEssentials(); }} className='btn-t1 br-3'><i className="bi bi-plus-circle"></i> New Request</Button>
                </div>
            </div>
            <div className="works-content-area">
                <div className="works-tab-content one">
                    {
                        leads !== undefined && Object.keys(leads).length > 0 ? (
                            Object.keys(leads).map((lead, i) => (
                                <div className="lead-card-item" key={lead}>
                                    <div className="lead-main-info">
                                        <div className="lead-card-title">
                                            {leads[lead].title ?? '-'}
                                        </div>
                                        <div className="lead-meta-row">
                                            <div className="lead-meta-item" title="Phone">
                                                <i className="bi bi-telephone"></i> {leads[lead].phone ?? '-'}
                                            </div>
                                            {leads[lead].name && (
                                                <span className="lead-meta-item">
                                                    <i className="bi bi-person"></i> {leads[lead].name}
                                                </span>
                                            )}
                                            <div className="lead-meta-item" title="Last Updated">
                                                <i className="bi bi-clock-history"></i> {formatDateTime(leads[lead].updated_at) ?? '-'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column align-items-end gap-2">
                                        <span className={`lead-status-pill lead-status-${(leads[lead].status ?? '').toLowerCase().replace(' ', '_')}`}>
                                            {(leads[lead].status ?? 'UNKNOWN').replace(/_/g, ' ')}
                                        </span>
                                        <button onClick={() => { getDetails(lead); }} className="lead-action-btn">
                                            Details <i className="bi bi-arrow-right ms-1"></i>
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : ''
                    }
                </div>
                <div className="works-tab-content" style={{ display: 'none' }}>

                </div>
            </div>
            <Modal show={newModal} onHide={() => setNewModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title >New Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={addEnquiry} >
                        <Row>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Contact number {phoneReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
                                    <div className="serach-customer d-grid pos-rel">
                                        <Form.Control onBlur={() => {
                                            setTimeout(() => {
                                                setShowAutoSuggestion(false);
                                            }, 100);
                                        }} autoComplete="off" onWheel={(e) => { e.target.blur() }} id="cus_phone" onChange={(e) => { searchCustomer(e.target.value) }} type="number" name="phone" className="shadow-none br-2" placeholder="Contact number" />

                                        {
                                            searchResult !== undefined && showAutoSuggestion ? (
                                                Object.keys(searchResult).length > 0 ? (
                                                    <div className="customer-search-results bdr1">
                                                        {
                                                            Object.keys(searchResult).map((cus, cus_index) => (
                                                                <span onClick={() => { setSelectedItem({ id: cus, profile: searchResult[cus] }) }} className={cus === Object.keys(searchResult)[selectCount] ? 'd-grid bdrb1 active' : 'd-grid bdrb1'} key={`cust_${cus_index}`}>{searchResult[cus].name} - {searchResult[cus].phone} </span>
                                                            ))
                                                        }
                                                    </div>
                                                ) : ''

                                            ) : ''
                                        }

                                    </div>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Name {nameReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
                                    <Form.Control type="text" id="cus_name" name="name" className="shadow-none br-2" placeholder="Customer Name" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label>Address</Form.Label>
                            <Form.Control as="textarea" id="cus_address" className="shadow-none br-2" name="address" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Enquiry Type {eqTitleErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
                            <Form.Select name='enquiry_type' >
                                <option value="">Select Enquiry Type</option>
                                {
                                    enquiryTypes !== undefined && Object.keys(enquiryTypes).length > 0 ? (
                                        Object.keys(enquiryTypes).map((enq_type, enq_type_i) => (
                                            enquiryTypes[enq_type].global ? (
                                                <option value={enq_type} key={`eqty_${enq_type_i}`} >{enquiryTypes[enq_type].name}</option>
                                            ) : ''
                                        ))
                                    ) : ''
                                }
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Enquiry details {eqDetailsErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
                            <Form.Control as="textarea" rows={4} className="shadow-none br-2" name="details" placeholder='Description about the enquiry' />
                        </Form.Group>
                        <div className="d-grid">
                            {
                                addEnquiryLoad ? (
                                    <Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
                                ) : (
                                    <Button type="submit" className="btn-t1"><i className="bi bi-floppy"></i> SAVE</Button>
                                )
                            }
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={detailModal} onHide={() => setDetailModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Lead Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        detailsLoad ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                <Spinner animation="border" variant="primary" />
                                <span className="ms-3 text-muted">Loading details...</span>
                            </div>
                        ) : (
                            details !== undefined && details.main ? (
                                <>
                                    <div className="lead-header-card">
                                        <div className="d-flex justify-content-between align-items-start mb-4">
                                            <div>
                                                <h4 className="mb-2 tp1 f20 f-bold">{details.main.name ?? '-'}</h4>
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    {details.main.company_name && (
                                                        <span className="badge bg-light text-dark border fw-normal px-2 py-1">
                                                            <i className="bi bi-building me-1"></i> {details.main.company_name}
                                                        </span>
                                                    )}
                                                    <span className={`badge ${details.main.is_closed ? 'bg-secondary' : 'bg-success'} px-2 py-1`}>
                                                        {details.main.status ?? 'Active'}
                                                    </span>
                                                    <span className="text-muted f12">
                                                        <i className="bi bi-calendar3 me-1"></i>
                                                        Created: {details.main.created_date}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <div className="f20 f-bold t-green">
                                                    ₹ {details.main.estimated_value ? parseFloat(details.main.estimated_value).toLocaleString() : '0'}
                                                </div>
                                                <small className="text-muted f12 text-uppercase fw-bold">Est. Value</small>
                                            </div>
                                        </div>

                                        <div className="lead-info-grid mb-4">
                                            <div className="lead-info-item">
                                                <label><i className="bi bi-telephone me-1"></i> Phone</label>
                                                <div>{details.main.phone ?? '-'}</div>
                                            </div>
                                            <div className="lead-info-item">
                                                <label><i className="bi bi-envelope me-1"></i> Email</label>
                                                <div>{details.main.email ?? '-'}</div>
                                            </div>
                                            <div className="lead-info-item">
                                                <label><i className="bi bi-geo-alt me-1"></i> Location</label>
                                                <div>{details.main.location ?? '-'}</div>
                                            </div>
                                            <div className="lead-info-item">
                                                <label><i className="bi bi-person-badge me-1"></i> Source</label>
                                                <div>{details.main.lead_source ?? '-'}</div>
                                            </div>
                                            <div className="lead-info-item">
                                                <label><i className="bi bi-person-check me-1"></i> Assigned To</label>
                                                <div>{details.main.assigned_to ?? '-'}</div>
                                            </div>
                                        </div>

                                        <div className="lead-desc-box">
                                            <h6 className="tp1 mb-2">{details.main.title ?? 'No Title'}</h6>
                                            <p className="mb-0 text-secondary f14">{details.main.desc ?? 'No description available.'}</p>
                                        </div>
                                    </div>

                                    {details.data && Object.keys(details.data).length > 0 && (
                                        <div className="px-2">
                                            <h5 className="mb-4 tp2 f-bold">Activity History</h5>
                                            <div className="timeline-container ms-2">
                                                {Object.values(details.data)
                                                    .sort((a, b) => {
                                                        const dateA = new Date(`${a.created_date} ${a.created_time}`);
                                                        const dateB = new Date(`${b.created_date} ${b.created_time}`);
                                                        return dateB - dateA;
                                                    })
                                                    .map((event, idx) => (
                                                        <div className="timeline-item" key={idx}>
                                                            <div className="timeline-dot"></div>
                                                            <div className="timeline-content">
                                                                <span className="timeline-time">
                                                                    <i className="bi bi-clock me-1"></i>
                                                                    {event.created_date} at {event.created_time}
                                                                </span>
                                                                <div className="timeline-title">
                                                                    {event.event_label}
                                                                    {event.event_type && <span className="badge bg-light text-secondary border ms-2 f12">{event.event_type}</span>}
                                                                </div>
                                                                {event.notes && (
                                                                    <div className="mt-2 text-secondary f14 border-top pt-2" style={{ borderColor: 'var(--primary-light)' }}>
                                                                        {event.notes}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="mb-3 text-muted">
                                        <i className="bi bi-inbox" style={{ fontSize: '3rem' }}></i>
                                    </div>
                                    <h5 className="text-muted">No details found</h5>
                                </div>
                            )
                        )
                    }
                </Modal.Body>
            </Modal>
        </Container>
    );
}